export default "__VITE_ASSET__ClFv8USj__"